const DEMO_SESSION_KEY = "inrange-demo-mode";

const readFromUrl = () => {
  const params = new URL(document.location.toString()).searchParams;
  return params.get("demo");
};

// Demo mode surfaces admin-only health/PR endpoints in the customer-app, which
// 401 for non-InRange users. Gate every path on the requesting user being
// InRange staff so the URL/sessionStorage overrides cannot leak demo UI to a
// real customer (e.g. a customer browsing on a shared machine, or a stale
// sessionStorage flag set under a different account).
const isInRangeUser = (user: { email?: string } | undefined): boolean =>
  user?.email?.endsWith("@inrange.io") ?? false;

export const isDemoModeEnabled = (
  orgDemo: boolean = false,
  user: { email?: string } | undefined = undefined
): boolean => {
  if (!isInRangeUser(user)) {
    return false;
  }
  if (orgDemo) {
    return true;
  }
  const fromUrl = readFromUrl();
  if (fromUrl === "true") {
    try {
      window.sessionStorage.setItem(DEMO_SESSION_KEY, "true");
    } catch {
      // sessionStorage may be unavailable (e.g. disabled cookies) — fall through
    }
    return true;
  }
  if (fromUrl === "false") {
    try {
      window.sessionStorage.removeItem(DEMO_SESSION_KEY);
    } catch {
      // ignore
    }
    return false;
  }
  try {
    return window.sessionStorage.getItem(DEMO_SESSION_KEY) === "true";
  } catch {
    return false;
  }
};
